import React, { FC } from 'react'

interface ISpinnerProps {
	className?: string
	size?: number // width and height in px
	thickness?: number // thickness of border
	durationSec?: number // speed
	spinnerColor?: string
}

const NewSpinner: FC<ISpinnerProps> = ({
	className,
	size = 24,
	thickness = 3,
	durationSec = 0.9,
	spinnerColor = '#000000'
}) => {
	const r = 12 - thickness / 2
	const dur = `${durationSec}s`

	return (
		<div className={className} style={{ width: size, height: size }}>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='100%'
				height='100%'
				viewBox='0 0 24 24'
				fill='none'
				role='img'
				aria-label='Загрузка'
			>
				<circle
					cx='12'
					cy='12'
					r={r}
					fill='none'
					stroke='#000000'
					strokeOpacity='0.12'
					strokeWidth={thickness}
				/>

				<circle
					cx='12'
					cy='12'
					r={r}
					fill='none'
					stroke={spinnerColor}
					strokeWidth={thickness}
					strokeLinecap='round'
					pathLength={100}
					strokeDasharray='25 75'
				>
					<animateTransform
						attributeName='transform'
						type='rotate'
						from='0 12 12'
						to='360 12 12'
						dur={dur}
						repeatCount='indefinite'
					/>
				</circle>
			</svg>
		</div>
	)
}

export default NewSpinner
